@use "../../../../../globals/settings";
@use "../../../../../globals/bcp";
@use "../../../../../globals/bcp-2022/objects/flyouts";

:host {
  display: block;
}

.profile-flyout-content__section {
  padding-top: flyouts.$padding-base;
  padding-bottom: flyouts.$padding-base;

  &--first {
    padding-top: 0;
  }

  &--last {
    padding-bottom: 0;
  }

  &--with-border {
    @include flyouts.separator("bottom");
  }
}

::slotted(f-list) {
  @include bcp.set-css-var(list, row-gap, 1rem);
  @include bcp.set-css-var(link, color, settings.$text-color);
  @include bcp.set-css-var(link, text-decoration, none);
}

// ------------------- CUSTOM -----------------------------------------------------------------------------------------
// ...
